import { render, staticRenderFns } from "./BActionsModal.vue?vue&type=template&id=286c3efa&scoped=true"
import script from "./BActionsModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./BActionsModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./BActionsModal.vue?vue&type=style&index=0&id=286c3efa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "286c3efa",
  null
  
)

export default component.exports